<template>
	<div class="contentMainDiv">
		<div style="color:red;">このページにアクセスする権限がありません</div>	
	</div>
</template>

